import gql from 'graphql-tag';


export const createMaterialAMSA = gql`
mutation createMaterialAMSA($data: [mdm_amsa_material_creation_insert_input!]!) {
  insert_mdm_amsa_material_creation(objects: $data) {
    returning {
      id
    }
  }
}
`;

export const updateMaterialAMSA = gql`
mutation updateMaterialAMSA($data: mdm_amsa_material_creation_set_input!, $id: Int!) {
  update_mdm_amsa_material_creation_by_pk(pk_columns: {id: $id}, _set: $data) {
    id
  }
}
`;

export const INSERT_WORKFLOW_STEP_LOG = gql`
mutation INSERT_WORKFLOW_STEP_LOG($action_id: Int!, $actual_step: Int, $before_step: Int, $comment: String = null, $material_creation_id: Int, $workflow_id: Int!, $action_date: timestamp = null, $end_action: timestamp = null) {
  logId: insert_mdm_amsa_step_log(objects: {action_id: $action_id, actual_step: $actual_step, before_step: $before_step, comment: $comment, material_creation_id: $material_creation_id, workflow_id: $workflow_id, action_date: $action_date, end_action: $end_action}) {
    returning {
      id
    }
  }
}
`;

export const UPDATE_WORKFLOW_STEP_LOG = gql`
mutation UPDATE_WORKFLOW_STEP_LOG($id: Int!, $comment: String = null, $end_action: timestamp) {
  update_mdm_amsa_step_log_by_pk(pk_columns: {id: $id}, _set: {end_action: $end_action, comment: $comment}) {
    id
  }
}
`;



// WEBPACK FOOTER //
// ./src/store/graphql/mutations/amsaCataloger.js